'use strict';

import ngResource from 'angular-resource';

class OemUserService {
  constructor($resource) {
    'ngInject';
    this.oem_api = $resource(
      '/api/oem/oem_user/:id',
      { id: '@id' },
      {
        index :  { method: 'GET',      isArray: true  },
        show  :  { method: 'GET',      isArray: false },
        create:  { method: 'POST',     isArray: false },
        update:  { method: 'PUT',      isArray: false },
        destroy: { method: 'DELETE',   isArray: false }
      }
    );

    this.manage_api = $resource(
      '/:mode/api/oem_user/:id',
      { id: '@id', mode: '@mode' },
      {
        index: { method: 'GET', isArray: true },
        create: { method: 'POST', isArray: false },
        destroy: { method: 'DELETE', isArray: false }
      }
    );
  }
}

export default angular.module('leptonApp.OemUserService', ['ngResource'])
  .service('OemUserService', ['$resource', OemUserService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/oem_user/oem_user.service.js